import { render } from "./FrequencyWatch.vue?vue&type=template&id=44e5904a&ts=true"
import script from "./FrequencyWatch.ts?vue&type=script&lang=ts&external"
export * from "./FrequencyWatch.ts?vue&type=script&lang=ts&external"

import "./FrequencyWatch.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__